import { render } from "./Candidates.vue?vue&type=template&id=298c4cd2&scoped=true"
import script from "./Candidates.vue?vue&type=script&lang=js"
export * from "./Candidates.vue?vue&type=script&lang=js"

import "./Candidates.vue?vue&type=style&index=0&id=298c4cd2&lang=scss&scoped=true"

import exportComponent from "/Users/amina/Desktop/streamup_amina/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298c4cd2"]])

export default __exports__